import '../../stylesheets/smart_phone/common.css'
import '../../stylesheets/smart_phone/original/my_page.css'
import '../../stylesheets/smart_phone/original/inquiry_requests.css'
import '../jquery'
import '../no_confrict'
require("src/smart_phone/jquery.alerts")